import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { doUnloadPlans } from 'store/plan/actions';
import { selectPlansPlanId } from 'store/plan/selectors';

import { Canvas } from './Pins/Canvas';
import { PlanListModal } from './PlanListModal';

export const PlanScreen: React.FC<ModalScreenProps<ModalScreens.PLANS>> = ({
  navigation,
  route,
}) => {
  const dispatch = useDispatch();
  const planId = useSelector(selectPlansPlanId);

  React.useEffect(() => {
    return () => {
      dispatch(doUnloadPlans());
    };
  }, [dispatch]);

  if (!planId) {
    return <PlanListModal route={{ params: {} }} />;
  }

  return <Canvas navigation={navigation} route={route} key={planId} />;
};
